import { useRef } from 'react';

import { Button, Flex, Text } from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import { ArrowLeftOutline } from '@aslanpay/portal-common-lib';

import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import ProfileSection from 'app/components/UI/ProfileSection';
import PasswordInfo from 'app/components/UI/PasswordInfo';
import ChangePasswordForm from 'app/components/Users/ChangePassword/ChangePasswordForm';

import { getBlankPath } from 'app/utils/routes';

function ChangePassword() {
  const submitButtonRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  return (
    <AuthenticatedPageWrapper title="Change Password">
      <Button
        my="10px"
        alignSelf="flex-start"
        size="sm"
        variant="link"
        leftIcon={<ArrowLeftOutline boxSize="20px" />}
        onClick={() => navigate(getBlankPath())}
      >
        Back
      </Button>
      <Flex gap="20px" align="flex-start" justify="space-between" ref={submitButtonRef}>
        <Text as="h2" textStyle="h2" color="brand.darkPurple">
          Change password
        </Text>
      </Flex>

      <Flex mt="20px" gap="60px" alignItems="flex-start">
        <ProfileSection title="Current and new passwords">
          <ChangePasswordForm ref={submitButtonRef} />
        </ProfileSection>
        <ProfileSection title="Password requirements">
          <PasswordInfo />
        </ProfileSection>
      </Flex>
    </AuthenticatedPageWrapper>
  );
}

export default ChangePassword;
